import { useEffect } from 'react';

export const useResizeObserver = (
  targetSelector: string,
  callback: () => void,
  maxRetries: number = 100
) => {
  useEffect(() => {
    let animationFrameId: number | null = null;
    let observer: ResizeObserver | null = null;
    let retryCount = 0;

    const checkTargetExistence = () => {
      if (retryCount >= maxRetries) {
        console.warn(
          'Max retries reached, giving up on finding the target:',
          targetSelector
        );
        return;
      }

      const targetNode = document.querySelector(targetSelector);
      if (targetNode) {
        observer = new ResizeObserver(() => {
          callback();
        });

        observer.observe(targetNode);
      } else {
        retryCount++;
        animationFrameId = requestAnimationFrame(checkTargetExistence);
      }
    };

    checkTargetExistence();

    return () => {
      if (observer) {
        observer.disconnect();
      }
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [targetSelector, callback, maxRetries]);
};
